//
//
//
//
//
//
//

import QuoteListItem from './QuoteListItem.vue'

export default {
  props: {
    quotes: {
      type: Array,
      default: null
    }
  },

  components: {
    QuoteListItem
  }
}  



// WEBPACK FOOTER //
// ./src/components/nav_quote/QuoteList.vue